var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-Index page-index"},[_c('div',{staticClass:"row main-row"},[_c('div',{staticClass:"side-frame padding-none"},[_c('SideMenuBar')],1),_c('div',{staticClass:"content-frame padding-none bg-color"},[_c('router-view'),_c('loadingView',{attrs:{"isVisible":_vm.$root.isSmLoading}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }